module.exports = __webpack_public_path__ + "assets/logo-crafty-component.bc3115dc.svg";